import React, {useEffect, useState }from 'react';
import { Modal, Row, Col, Card, Button } from 'react-bootstrap';
import axios from 'axios';
import MessageModal from './MessageModal';

const BuyNowPackage = (props) => {
    
    const [packages, setPackages] = useState(false);
    const [pkgList, setPkgList] =  useState(false);
    const [message, setMessage] = useState(false);
    const [displayEles, setDisplayEles] = useState({cloudInfo: true, nonCloudInfo : true, pkgList : false });

    const fetchPackages = () => {
        // axios.get(`http://localhost/KS/js/pkgs.json`)
        axios.get(`${process.env.REACT_APP_URL}js/pkgs.json`)
        .then(res => {
            if(res.status == 200)  setPackages(res.data.packages);
            else setMessage('There is some error. Please try again.');
            
        })
        .catch(err => console.log('Buy Now Package fetch error : ' , err));
    }

    useEffect(() => fetchPackages(), []);

    const showCloudList = (e) => {
        showPlan(1);
    }

    const showNonCloudList = e => {
        showPlan(0);
    }

    const showPlan = (cloud) => {
        if(cloud == 0){
            const pkgs = packages.filter( p => parseInt(p.cloud) == cloud);
            setPkgList(pkgs);
            setDisplayEles({...displayEles, cloudInfo: false, pkgList : true});
        }
        else{
            const pkgs = packages.filter( p => parseInt(p.cloud) == cloud);
            setPkgList(pkgs);
            setDisplayEles({...displayEles, nonCloudInfo: false, pkgList : true});
        }
    }

    const restorePlans = (e) => {
        setDisplayEles({cloudInfo : true, nonCloudInfo : true, pkgList : false});
    }

    const handleBuy = (id) => e => {
        window.location.href = `${process.env.REACT_APP_URL}svasu/buy/${id}`; 
    }

    const getPlan = (pkg) => {
        
        return <Card className="prd-card mx-3 mb-4" onClick={handleBuy(pkg.id)}>
            <Row className={`pkg-category justify-content-center cat-${pkg.category} `}>
                <div className={` ${pkg.category}`}>{pkg.category}</div>
            </Row>
            <Row>
                <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none" className={`svg-${pkg.category}`}>
                     <path fill="#fff" d="M 985.66 92.83 C 906.67 72 823.78 31 743.84 14.19 c -82.26 -17.34 -168.06 -16.33 -250.45 0.39 c -57.84 11.73 -114 31.07 -172 41.86 A 600.21 600.21 0 0 1 0 27.35 V 120 H 1200 V 31.8 C 1063.19 91.92 917.71 76.31 782.66 30.83 Z" className="shape-fill"></path>
                </svg>
            </Row>
            <div className={`prd-desc prd-desc-${pkg.category}`}>
                <div className={`${parseInt(pkg.cloud) === 1? 'prd-desc-cloud' : 'prd-desc-no-cloud'}`}>
                    <Row>
                        <Col className="text-right actual">
                            {(parseInt(pkg.actual_price) - parseInt(pkg.offer_price)) > 0 &&  <>&nbsp;${parseInt(pkg.actual_price)}&nbsp;</>}
                        </Col>
                        <Col className="offer text-center">
                            ${pkg.offer_price == '' ? pkg.actual_price : pkg.offer_price} 
                        </Col>
                        <Col className="text-left saving">
                            {(parseInt(pkg.actual_price) - parseInt(pkg.offer_price)) > 0 && <span><strong>Save</strong> ${parseInt(pkg.actual_price) - parseInt(pkg.offer_price)}</span>}
                        </Col>
                    </Row>
                    {parseInt(pkg.cloud) === 1 && <Row className="justify-content-center">
                            <div onClick={handleBuy(pkg.id)}>
                                <b className="storage">{parseInt(pkg.storage) + parseInt(pkg.extra_storage)} GB</b> cloud space</div>
                    </Row>}
                    <Row className="justify-content-center">
                        {pkg.title}
                    </Row>
                    {pkg.category !== 'Essential' && <Row className="justify-content-center"><u><strong><i>Latest Offers!</i></strong></u></Row>}
                    { parseFloat(pkg.extra_validity) > 0 && <Row className="justify-content-center">{pkg.offer_line} &nbsp;<b>Extra Validity</b></Row>}
                    <Row className="justify-content-center">
                        Total Validity &nbsp;
                            {parseInt(pkg.extra_validity) > 0 && <span>{pkg.actual_validity} days</span>} <b>&nbsp;
                            {parseInt(pkg.actual_validity) + parseInt(pkg.extra_validity)} Days</b>
                    </Row>
                    {parseInt(pkg.cloud) === 1 && <Row className="justify-content-center">
                        {parseInt(pkg.extra_storage) > 0 && <div>
                            <b>+ {pkg.extra_storage} GB</b> Extra Free! = {parseInt(pkg.storage) + parseInt(pkg.extra_storage)} GB
                        </div>}
                    </Row>}
                </div>
                <div>
                    <Row className="justify-content-center mb-2">
                        <Button className="btn btn-buy" onClick={handleBuy(pkg.id)}>Buy Now</Button>
                    </Row>
                </div>
            </div>
        </Card>
    }

    return <Modal show onHide={props.onHide} centered size="xl" >        
        <Modal.Body >
            <div>
                <Row className="justify-content-center mb-5">
                    <div className='ourpkgs'>
                        <h2>Our Packages</h2>
                    </div>                    
                </Row>
                <Row className="mb-5">
                    {displayEles.cloudInfo && <Col className='col-12' lg={displayEles.pkgList ? 4 : 6}>
                        <div className={`${displayEles.pkgList ? 'showplan': 'info-box'}`}>
                                <Row className="justify-content-center">
                                    <div className="info-logo ">
                                        <img src="https://www.svasu.cloud/images/Logo-blk.png" className="" alt="best pdf to scorm converter" />    
                                    </div>                                
                                </Row>
                                <Row className="justify-content-center crs-type">
                                    <h2>With Cloud Space</h2>
                                </Row>
                                <Row className="text-center">
                                    <div className={`info-desc ${displayEles.pkgList ? 'info-list-height' : '' }`}>
                                        <p>Create scorm-based courses/packages and save them on the <strong>SVASU CLOUD</strong> server. <br />
                                        Be relaxed about the safety and security of your data. <br />
                                        Focus specifically on your training.</p>
                                    </div>
                                </Row>
                                <Row className="justify-content-center">
                                    {!displayEles.pkgList && <button className="btn btn-plan text-white" onClick={showCloudList}>Choose Plan</button>}
                                    {displayEles.pkgList && <button className="btn btn-plan text-white"  onClick={restorePlans}>Back</button>}
                                </Row>
                        </div>

                    </Col>}
                    {displayEles.nonCloudInfo && <Col className='col-12' lg={displayEles.pkgList ? 4 : 6}>
                        <div className={`${displayEles.pkgList ? 'showplan': 'info-box'}`}>
                            <Row className="justify-content-center">
                                <div className="info-logo">
                                    <img src="https://www.svasu.cloud/images/Logo-blk.png" className="" alt="best pdf to scorm converter" />    
                                </div>
                            </Row>
                            <Row className="justify-content-center  crs-type">
                                <h2>Without Cloud Space</h2>
                            </Row>
                            <Row className="text-center">
                                <div className={`info-desc p-4 no-cloud ${displayEles.pkgList ? 'info-list-height' : '' }`}>
                                    <p>You are free to create <strong>SVASU scorms</strong> and download them to your local system for further use.<br />
                                    We will not be having any copy of your package/course. </p>
                                </div>
                            </Row>
                            <Row className='justify-content-center'>
                                {!displayEles.pkgList && <button className="btn btn-plan text-white" onClick={showNonCloudList}>Choose Plan</button>}
                                {displayEles.pkgList && <button className="btn  btn-plan text-white"  onClick={restorePlans}>Back</button>}
                            </Row>
                        </div>
                    </Col>}
                    {displayEles.pkgList && <Col>
                        <Row>
                            {pkgList && pkgList.map((pkg, idx) => <Col className="col-12"  lg={6} >{getPlan(pkg)}</Col>)}
                        </Row>
                        
                    </Col>}
                </Row>
            </div>
        </Modal.Body>
        <Modal.Footer>
            <div className="cloud-cont nottext">
                <div className="note">Corporate users looking for specific customization and configurations in file size limits may <a className="clickable upgrade-contact"  href={`https://svasu.cloud/contact-us.html`}>contact us</a>.
                </div>
                <div className="note">Maximum size limit per course – 50 MB </div>
            </div>  
        </Modal.Footer>

    </Modal>
}

export default BuyNowPackage;